// ========================================
// 双通道初始化引导 — 前后端分离 V6
// 通道1: 从 /api/me/ 获取配置（新方式）
// 通道2: 回退到 index.html 注入的 window.APP_SETTINGS（兜底）
// ========================================

import { API_GATEWAY } from './env';

async function bootstrap() {
  // ========================================
  // Token 自动登录：检测 URL 中的 tk 参数
  // 用法: ?tk=<DRF_TOKEN>  登录成功后自动去除参数
  // ========================================
  const urlParams = new URLSearchParams(window.location.search);
  const tokenKey = urlParams.get('tk');

  if (tokenKey) {
    try {
      const loginRes = await fetch(`${API_GATEWAY || ''}/api/auth/token-login/?tk=${encodeURIComponent(tokenKey)}`, {
        credentials: 'include',
      });

      if (loginRes.ok) {
        const loginData = await loginRes.json();
        if (loginData.success) {
          console.log('[token-login] 自动登录成功:', loginData.user?.email);
          // 安全：从 URL 中移除 tk 参数，防止 token 泄露
          urlParams.delete('tk');
          const newSearch = urlParams.toString();
          const newUrl = window.location.pathname + (newSearch ? '?' + newSearch : '') + window.location.hash;
          window.history.replaceState(null, '', newUrl);
        } else {
          console.warn('[token-login] 自动登录失败:', loginData.error);
        }
      } else {
        console.warn('[token-login] 接口返回非 200:', loginRes.status);
      }
    } catch (e) {
      console.error('[token-login] 网络错误:', e);
    }
  }

  // 并行：提前下载 App 模块，不等 /api/me/ 返回
  const appPromise = import('./app/App');

  // 通道1：优先从 /api/me/ 获取最新配置（带超时兜底，最多等待 8 秒）
  const settingsPromise = fetch(`${API_GATEWAY || ''}/api/me/`, { credentials: 'include', cache: 'no-cache' })
    .then(res => res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`)))
    .then(settings => {
      (window as any).APP_SETTINGS = settings;
      window.dispatchEvent(new CustomEvent('app-settings-ready'));
      console.log('[bootstrap] APP_SETTINGS loaded from /api/me/');
    })
    .catch(e => {
      console.warn('[bootstrap] /api/me/ failed:', e);
    });

  await Promise.race([settingsPromise, new Promise<void>(resolve => setTimeout(resolve, 8000))]);

  // 如果超时未拿到数据，使用 index.html 的兜底值
  if (!(window as any).APP_SETTINGS) {
    console.warn('[bootstrap] /api/me/ timed out, using fallback');
    (window as any).APP_SETTINGS = {
      debug: true,
      hostname: window.location.origin,
      flags: {},
      billing: {},
      version: {},
    };
  }

  // App 模块已并行下载，此时大概率已就绪
  await appPromise;
  import('./utils/service-worker');
}

bootstrap();